import React from 'react';

import { ModalFooter } from './Footer.styled';

const Footer = ({ children }) => {
  return <ModalFooter>{children}</ModalFooter>;
};

export default Footer;
